import { FC, useState } from 'react';
import { faBan } from '~/assets';
import { IconProp, observer, useLocation, useNavigate } from '~/modules';
import {
  goToHome,
  goToOnboardingIntro,
  handleNewCredit,
  useStores,
} from '~/utils';
import ErrorScene from './ErrorScene';

interface ErrorSceneContainerProps {
  title?: string;
  subtitle?: string;
  icon?: IconProp;
  primaryButton?: string;
  primaryButtonText?: string;
  secondaryButton?: string;
  secondaryButtonText?: string;
}

const ErrorSceneContainer: FC<ErrorSceneContainerProps> = ({
  title = 'Ops! Algo deu errado',
  subtitle,
  icon = faBan,
  primaryButton,
  secondaryButton,
  primaryButtonText,
  secondaryButtonText,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { creditProducts } = useStores();
  const state = location.state as Partial<ErrorSceneContainerProps> | null;

  const getButtonFunction = (onPress) => {
    switch (onPress) {
      case 'goToHome':
        return () => goToHome(creditProducts, navigate);
      case 'handleNewCredit':
        return () => handleNewCredit(creditProducts, navigate, setIsLoading);
      case 'goToOnboardingIntro':
        return () => goToOnboardingIntro(navigate);
      default:
        return () => goToHome(creditProducts, navigate);
    }
  };

  const primaryButtonObj = {
    text: state?.primaryButtonText || primaryButtonText,
    onPress: getButtonFunction(state?.primaryButton || primaryButton),
  };

  const secondaryButtonObj = {
    text: state?.secondaryButtonText || secondaryButtonText,
    onPress: getButtonFunction(state?.secondaryButton || secondaryButton),
  };

  return (
    <ErrorScene
      title={state?.title || title}
      subtitle={state?.subtitle || subtitle}
      icon={state?.icon || icon}
      primaryButton={primaryButtonObj}
      secondaryButton={secondaryButtonObj}
      isLoading={isLoading}
    />
  );
};

export default observer(ErrorSceneContainer);
